import React, { useEffect } from 'react'
import {useDispatch, useSelector} from 'react-redux';
import { Button as ReactStrapButton } from 'reactstrap';
import { ccaa_actions } from '../../store/ccaa_slice';

//import all components
import Annual_Reporting_Summary from './Annual_Reporting_Summary';
import Annual_Net_Conservation from './Annual_Net_Conservation';
import Summary_Effectiveness from './Summary_Effectiveness';
import Upcoming_Year_Forecast from './Upcoming_Year_Forecast';

import { useReactToPrint } from 'react-to-print';
import ReactToPrint from 'react-to-print';


import { CSVLink } from "react-csv";


  import {
      Card,
    Typography
  } from 'antd';

  import {
    Text,
  } from '@chakra-ui/react';


  const { Title } = Typography;

function Monarch_form_values() {
  //redux state
    const dispatch = useDispatch();

    //all components ref
    const annual_reporting_summary_ref = React.useRef();
    const annual_net_conservation_ref = React.useRef();
    const summary_of_effectiveness_ref = React.useRef();
    const upcoming_year_forecast_ref = React.useRef();



    const annual_reporting_summary_store = useSelector(state => state.ccaa.annual_reporting_summary_store);
    const annual_net_conservation_store = useSelector(state => state.ccaa.annual_net_conservation_store);
    const summary_of_effectiveness_store = useSelector(state => state.ccaa.summary_effectiveness_store);
    const upcoming_year_forecast_store = useSelector(state => state.ccaa.upcoming_year_forecast_store);
    const organization_name = useSelector(state => state.ccaa.organization_name_store);

    const csv_data = [
        {data_column:"Acres Enrolled", data_value:annual_reporting_summary_store.acres_enrolled},
        {data_column:"Acres Target", data_value:annual_reporting_summary_store.acres_target},
        {data_column:"Acres Contributed", data_value:annual_reporting_summary_store.acres_contributed},
        {data_column:"Additional Explanation", data_value:annual_reporting_summary_store.additional_explanation},
        {data_column:"Conservation Measures", data_value:annual_net_conservation_store.conservation_measures},
        {data_column:"Conservation Measures Implementation", data_value:annual_net_conservation_store.conservation_measures_implementation},
        {data_column:"Partners Overlap", data_value:annual_net_conservation_store.partners_overlap},
        {data_column:"Supplement Measures", data_value:annual_net_conservation_store.supplement_measures},
        {data_column:"Additional Supplement Conservation Measures", data_value:annual_net_conservation_store.additional_supplement_conservation_measures},
        {data_column:"Updates to Section 7", data_value:annual_net_conservation_store.updates_to_section_7},
        {data_column:"Methods Effective Monitoring", data_value:summary_of_effectiveness_store.methods_effective_monitoring},
        {data_column:"Monitoring Results Summary", data_value:summary_of_effectiveness_store.monitoring_results_summary},
        {data_column:"Adaptive Management Triggered", data_value:summary_of_effectiveness_store.adaptive_management_triggered},
        {data_column:"Adaptive Management Actions", data_value:summary_of_effectiveness_store.adaptive_management_actions},
        {data_column:"Supplemental Effectiveness Monitoring", data_value:summary_of_effectiveness_store.supplemental_effectiveness_monitoring},
        {data_column:"Anticipate Updates", data_value:upcoming_year_forecast_store.anticipate_updates},
        {data_column:"General Comments", data_value:upcoming_year_forecast_store.general_comments},
    ];

    const csv_columns = [
        {label: "Data Column", key: "data_column"},
        {label: "Data Value", key: "data_value"}
    ];

    useEffect(() => {
        // if(annual_net_conservation_store.conservation_measures){
        //     dispatch(ccaa_actions.convert_to_string_conservation_measures());
        // }
        // if(annual_net_conservation_store.supplement_measures){
        //     dispatch(ccaa_actions.convert_to_string_supplement_measures());
        // }
        // if(annual_net_conservation_store.updates_to_section_7){
        //     dispatch(ccaa_actions.convert_to_string_updates_to_section_7());
        // }
        // if(summary_of_effectiveness_store.adaptive_management_triggered){
        //     dispatch(ccaa_actions.convert_to_string_adaptive_management_triggered());
        // }
    }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div className='col-md-8'>
                <Title level={3}>Monarch CCAA 2024 Annual Report Summary</Title>
            </div>
            <div className='col-md-2'>
                <div>
                <CSVLink data={csv_data} headers={csv_columns} filename={"monarch_ccaa_form_values.csv"}>
                    <button className="btn btn-primary btn-sm">Download Report Summary</button>
                </CSVLink>
                </div>
            </div>
            <div className='col-md-2'>
                <ReactToPrint
                    trigger={() => <button className="btn btn-primary btn-sm">Print Report Summary</button>}
                    bodyClass="print-body"
                    content={() => annual_reporting_summary_ref.current}
                    documentTitle="Monarch CCAA 2023 Annual Report Summary"
                    pageStyle={
                        "@page { size: landscape; margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; } }"
                    }
                />
            </div>
            <div style={{ display: "none" }}>
                <div ref={annual_reporting_summary_ref}>
                    <Annual_Reporting_Summary/>
                    <Annual_Net_Conservation/>
                    <Summary_Effectiveness/>
                    <Upcoming_Year_Forecast/>
                </div>
            </div>
        </div>
        <div className='row'>
            <Text>Organization Name: {organization_name} </Text>
        </div>
        <div className='row'>
            <div className='p-4 m-4 col-md-11 border-1 rounded-3 border-dark border-background'>
                <Title level={4}>Annual Reporting Summary</Title>
                <hr/>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Acres Enrolled:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_reporting_summary_store.acres_enrolled}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Acres Target:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_reporting_summary_store.acres_target}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Acres Contributed:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_reporting_summary_store.acres_contributed}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Additional Explanation:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_reporting_summary_store.additional_explanation}</Text>
                    </div>
                </div>
            </div>
        </div>

        <div className='row'>
            <div className='p-4 m-4 col-md-11 border-1 rounded-3 border-dark border-background'>
                <Title level={4}>Annual Net Conservation</Title>
                <hr/>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Conservation Measures:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_net_conservation_store.conservation_measures?annual_net_conservation_store.conservation_measures.toString():''}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Conservation Measures Implementation:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_net_conservation_store.conservation_measures_implementation}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Partners Overlap:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_net_conservation_store.partners_overlap}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Supplement Measures:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_net_conservation_store.supplement_measures?annual_net_conservation_store.supplement_measures.toString():''}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Additional Supplement Conservation Measures:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_net_conservation_store.additional_supplement_conservation_measures}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Updates to Section 7:</Text>
                    <div className='col-md-9'>
                        <Text>{annual_net_conservation_store.updates_to_section_7?annual_net_conservation_store.updates_to_section_7.toString():''}</Text>
                    </div>
                </div>
            </div>
        </div>

        <div className='row'>
            <div className='p-4 m-4 col-md-11 border-1 rounded-3 border-dark border-background'>
                <Title level={4}>Summary of Effectiveness</Title>
                <hr/>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Methods Effective Monitoring:</Text>
                    <div className='col-md-9'>
                        <Text>{summary_of_effectiveness_store.methods_effective_monitoring}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Monitoring Results Summary:</Text>
                    <div className='col-md-9'>
                        <Text>{summary_of_effectiveness_store.monitoring_results_summary}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Adaptive Management Triggered:</Text>
                    <div className='col-md-9'>
                        <Text>{summary_of_effectiveness_store.adaptive_management_triggered?summary_of_effectiveness_store.adaptive_management_triggered.toString():''}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Adaptive Management Actions:</Text>
                    <div className='col-md-9'>
                        <Text>{summary_of_effectiveness_store.adaptive_management_actions}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Supplemental Effectiveness Monitoring:</Text>
                    <div className='col-md-9'>
                        <Text>{summary_of_effectiveness_store.supplemental_effectiveness_monitoring}</Text>
                    </div>
                </div>
            </div>
        </div>

        <div className='row'>
            <div className='p-4 m-4 col-md-11 border-1 rounded-3 border-dark border-background'>
                <Title level={4}>Upcoming Year Forecast</Title>
                <hr/>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Anticipate Updates Description:</Text>
                    <div className='col-md-9'>
                        <Text>{upcoming_year_forecast_store.anticipate_updates}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>General Comments:</Text>
                    <div className='col-md-9'>
                        <Text>{upcoming_year_forecast_store.general_comments}</Text>
                    </div>
                </div>
                <div className='mt-2 row'>
                    <Text className='col-md-3'>Suggesstions for CCAA:</Text>
                    <div className='col-md-9'>
                        <Text>{upcoming_year_forecast_store.suggestions_for_ccaa}</Text>
                    </div>
                </div>

            </div>
        </div>
        
    </div>
  )
}

export default Monarch_form_values
